/**
 * Every screen's `<h1>`, with `tabIndex={-1}` so `AppShell` can move focus to it
 * after a route change.
 *
 * A component rather than a convention: `AppShell` looks for an `h1` inside `<main>`
 * and focuses it, and an `<h1>` without `tabIndex={-1}` is not focusable — the call
 * would silently do nothing and the regression would be invisible in every test that
 * does not assert on `document.activeElement`. Making the heading a component means
 * the attribute cannot be forgotten by the nine screens that come after this task.
 */

import type { ReactNode } from 'react';

export interface ScreenHeadingProps {
  readonly children: ReactNode;
  readonly testId?: string;
}

export function ScreenHeading({
  children,
  testId = 'screen-heading',
}: ScreenHeadingProps): ReactNode {
  return (
    <h1 className="wp-screen-title" tabIndex={-1} data-testid={testId}>
      {children}
    </h1>
  );
}
